import {startInactivityAutoPlay} from "./preview_autoplay";

// Thin wrapper so featured-card autoplay can be tested independently of
// preview_autoplay; add kind-specific branching here when needed.
export function startFeaturedAutoplayIfApplicable(attributes) {
    startInactivityAutoPlay(attributes['preview_url']);
}
